import { IChip } from '../components/field-selection/field-config/field-options/conditions/conditions.component';

export type ConditionValue = string | number | boolean | IChip[];
export type NoFieldCondition = undefined;

/**
 * Represents the condition for a field.
 * This will be serialized into the SerializedFieldContext object.
 */
export class Condition {
  static NoCondition: NoFieldCondition = undefined;
  fieldPath: string;
  fieldType: string;
  operator: string;
  value: ConditionValue;

  constructor(fieldPath: string, fieldType: string, operator: string, val: ConditionValue) {
    this.fieldPath = fieldPath;
    this.fieldType = fieldType;
    this.operator = operator;
    this.value = val;
  }
}
